const ACTIVATION_BULLETS = [
  'Pause all student dismissals',
  'Notify staff devices',
  'Notify parents',
  'Update classroom smartboards',
  'Lock active dismissal operations',
  'Notify Car-Pool emergency response team',
];

export default function EmergencyLockdownModal({
  phase = 'confirm',
  onClose,
  onActivate,
  onEnd,
  activating = false,
  ending = false,
}) {
  return (
    <div className="sd-support-overlay sd-lockdown-overlay" onClick={onClose}>
      <div
        className="sd-lockdown-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="sd-lockdown-title"
      >
        <button
          type="button"
          className="sd-lockdown-back"
          onClick={onClose}
          aria-label="Close"
        >
          ←
        </button>

        {phase === 'confirm' ? (
          <>
            <div className="sd-lockdown-card">
              <h2 id="sd-lockdown-title" className="sd-lockdown-title">Emergency Mode</h2>
              <p className="sd-lockdown-lede">Activating emergency mode will immediately:</p>
              <ul className="sd-lockdown-list">
                {ACTIVATION_BULLETS.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>

            <button
              type="button"
              className="sd-lockdown-cta"
              onClick={onActivate}
              disabled={activating}
            >
              {activating ? 'ACTIVATING…' : 'LOCKDOWN'}
            </button>
          </>
        ) : (
          <>
            <div className="sd-lockdown-card sd-lockdown-card-active">
              <h2 id="sd-lockdown-title" className="sd-lockdown-title-active">LOCKDOWN ACTIVE</h2>
              <p className="sd-lockdown-active-copy">
                Follow established school lockdown procedures
                <br />
                Student dismissal has been suspended until further notice.
              </p>
            </div>

            <button
              type="button"
              className="sd-lockdown-cta"
              onClick={onEnd}
              disabled={ending}
            >
              {ending ? 'ENDING…' : 'END LOCKDOWN'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
